import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  või maksa kolmes osas 0% intress ja 0 € lepingutasu!

  <span style="color:#85c1dc;">**FI:**</span>
  

  <span style="color:#85c1dc;">**RU:**</span>
  
*/
/* @__NO_SIDE_EFFECTS__ */
const m1222 = msg(
  mf`või maksa kolmes osas 0% intress ja 0 € lepingutasu!`,
  mf``,
  mf``,
)

export { m1222 as 'w.module.product_hero.monthly_price_info' }